import Location from "../config/location";
import Utility from "./utility";
import PageNames from "../config/pageNames";
import { defaultNextgenPathname } from "../config/apiEndpoints";
import { DEFAULT_STORE } from "./paymentConstants";

const setLocalStorageValue = (key, value) => localStorage.setItem(key, value);

const getStorageValue = (key) => localStorage.getItem(key);

const getLastLocationNewOrLastLocationNewForIp = () => {
  let _ = Utility.tryJsonParse(localStorage.lastLocationNew);
  if (Object.keys(_).length > 0) return _;
  _ = Utility.tryJsonParse(localStorage.lastLocationNewForIp);
  if (Object.keys(_).length > 0) return _;
  return [];
};

const isMiniAppPaytmGpay = () => {
  let _ = localStorage.isMiniapp ? localStorage.isMiniapp : false;

  let queryParams = Utility.getQueryFromUrl();
  if (
    queryParams["utm_source"] == "PAYTM" ||
    queryParams["utm_source"] == "GPAY"
  ) {
    localStorage.isMiniapp = queryParams["utm_source"];
    return queryParams["utm_source"];
  }

  if (_ == "PAYTM" || _ == "GPAY") {
    return _;
  }

  return false;
};

const getIsLocationPermisssionGiven = () => {
  return localStorage.isLocationPermissionGiven
    ? Utility.tryJsonParse(localStorage.isLocationPermissionGiven)
    : false;
};

const nearestApiTopAddress = () => {
  return sessionStorage.nearestApiTopAddress
    ? JSON.parse(sessionStorage.nearestApiTopAddress)
    : "";
};

const setNearestApiTopAddress = (payload) => {
  sessionStorage.nearestApiTopAddress = payload ? JSON.stringify(payload) : "";
};

const setIsLocationPermissionGiven = () => {
  localStorage.isLocationPermissionGiven = JSON.stringify(true);
};

const setAskLocationLaterInSession = () => {
  sessionStorage.askLocationLater = JSON.stringify(true);
};

const setTrackerOfKeyInSession = (bol) => {
  sessionStorage.isTrackerStatusOpen = JSON.stringify(bol);
};

const getSgRefundAmt = () => {
  return localStorage.getItem("TOTAL_REFUND_AMT")
    ? localStorage.getItem("TOTAL_REFUND_AMT")
    : "";
};

const getAskLocationLaterFromSession = () => {
  return sessionStorage.askLocationLater
    ? Utility.tryJsonParse(sessionStorage.askLocationLater)
    : false;
};

const setHideLocationPopupOnceInSession = () => {
  sessionStorage.hideLocationPopupOnce = JSON.stringify(true);
};

const getHideLocationPopupOnceFromSession = () => {
  return sessionStorage.hideLocationPopupOnce
    ? Utility.tryJsonParse(sessionStorage.hideLocationPopupOnce)
    : false;
};

const conditionalPurgeStorage = () => {
  let liveStorageNumber = +window._siteProps_?.props?.storageNumber;
  let localStorageNumber = localStorage.storageNumber;
  if (liveStorageNumber && liveStorageNumber > localStorageNumber) {
    localStorage.clear();
    sessionStorage.clear();
    localStorage.storageNumber = liveStorageNumber;
  } else if (liveStorageNumber) {
    localStorage.storageNumber = liveStorageNumber;
  }
};

const cartId = () => {
  return localStorage.userInfo
    ? Utility.tryJsonParse(localStorage.userInfo)?.headers?.cartId
    : "";
};

const getCartData = () => {
  return localStorage.cartData
    ? Utility.tryJsonParse(localStorage.cartData)
    : "";
};

const setNoDeliveryZoneInSession = (value) => {
  sessionStorage.noDeliveryLocation = JSON.stringify(value);
  return;
};

const getReturnedFromMapScreen = () => {
  return localStorage.returnedFromMapScreen
    ? Utility.tryJsonParse(localStorage.returnedFromMapScreen)
    : false;
};

const setReturnedFromMapScreen = () => {
  localStorage.returnedFromMapScreen = JSON.stringify(true);
};

const setIsStoreIdCacheEligible = () => {
  let time = new Date().getTime() + 3 * 86400000;
  if (isLocationSelectedFromPwaV2()) {
    sessionStorage.isStoreIdCacheEligibleForPWAV2 = JSON.stringify(time);
  }
  sessionStorage.isStoreIdCacheEligible = JSON.stringify(time);
};

const getIsStoreIdCacheEligible = () => {
  try {
    let currentTime = new Date().getTime();
    if (isLocationSelectedFromPwaV2()) {
      return sessionStorage.isStoreIdCacheEligibleForPWAV2
        ? Utility.tryJsonParse(sessionStorage.isStoreIdCacheEligibleForPWAV2) >
            currentTime
        : false;
    }
    return sessionStorage.isStoreIdCacheEligible
      ? Utility.tryJsonParse(sessionStorage.isStoreIdCacheEligible) >
          currentTime
      : false;
  } catch (e) {
    return false;
  }
};

const setComputedLocationData = (payload) => {
  sessionStorage.computedLocationData = JSON.stringify(payload);
};

const getComputedLocationData = () => {
  return sessionStorage.computedLocationData
    ? Utility.tryJsonParse(sessionStorage.computedLocationData)
    : {};
};

const getPreviousStoreId = () => {
  return sessionStorage.previousStoreId
    ? Utility.tryJsonParse(sessionStorage.previousStoreId)
    : {};
};

const setIsTrueLocationDetected = (payload) => {
  sessionStorage.isTrueLocationDetected = JSON.stringify(payload);
};

const getIsTrueLocationDetected = () => {
  return sessionStorage.isTrueLocationDetected
    ? Utility.tryJsonParse(sessionStorage.isTrueLocationDetected)
    : false;
};

const getLocationSource = () => {
  return getLastLocationNewOrLastLocationNewForIp()[0]?.source || "";
};

const isLocationSelectedFromPwaV2 = () => {
  return (
    sessionStorage.lastLocationNewSource &&
    sessionStorage.lastLocationNewSource == "pwa-v2"
  );
};

const setLocationSelectedFromPwaV2 = () => {
  sessionStorage.lastLocationNewSource = "pwa-v2";
};

const unsetSessionStorageKey = (key) => {
  sessionStorage.removeItem(key);
};

const setSessionStorageKey = (key, value = {}) => {
  if (!key) return;
  sessionStorage[key] = JSON.stringify(value);
};

const getSessionStorageKey = (key) => {
  return sessionStorage[key] ? Utility.tryJsonParse(sessionStorage[key]) : {};
};

const getSessionStorageValuePwaV2Keys = (key, defaultValue = "") => {
  return sessionStorage[key] || defaultValue;
};

const setLocationSource = (value) => {
  localStorage.locationSource = value;
};

const getUserData = () => {
  return localStorage.userInfo
    ? Utility.tryJsonParse(localStorage.userInfo)
    : {};
};
const getCorporateUserInfo = () => {
  return localStorage.CorporateUserInfo
    ? Utility.tryJsonParse(localStorage.CorporateUserInfo)
    : {};
};

const setCorporateUserInfo = (data) => {
  return localStorage.setItem("CorporateUserInfo", JSON.stringify(data));
};

const setLoyTnc = (flag = false) => {
  sessionStorage.loyTnc = JSON.stringify(flag);
};

const getLoyTnc = () => {
  return sessionStorage.loyTnc
    ? Utility.tryJsonParse(sessionStorage.loyTnc)
    : false;
};

const getUserId = () => {
  return localStorage.userInfo
    ? Utility.tryJsonParse(localStorage.userInfo)?.headers?.userId
    : "";
};

const setUserData = (data) => {
  localStorage.userInfo = JSON.stringify(data);
};

const getAddressDetail = () => {
  let addressDetail = localStorage.addressDetail;

  try {
    return JSON.parse(addressDetail);
  } catch {
    return addressDetail;
  }
};

const setAddressDetail = (data) => {
  localStorage.addressDetail = data;
};

const setUserAddress = (data) => {
  localStorage.userAddresses = JSON.stringify(data);
};

const getCoordsFromRecentLocation = () => {
  let value = getLastLocationNewOrLastLocationNewForIp()[0];
  if (value?.location?.latitude) {
    value = {
      coords: {
        latitude: value.location.latitude,
        longitude: value.location.longitude,
      },
      storeId: value.recent?.id,
    };
  } else if (value?.recent?.addressComponent?.latitude) {
    value = {
      coords: {
        latitude: value.recent.addressComponent.latitude,
        longitude: value.recent.addressComponent.longitude,
      },
      storeId: value.recent?.id,
    };
  } else if (value?.recent?.latitude) {
    value = {
      coords: {
        latitude: value.recent.latitude,
        longitude: value.recent.longitude,
      },
      storeId: value.recent?.id,
    };
  }
  return value;
};

const getCoordsForTakeaway = () => {
  let _ = sessionStorage.takeawayLocation
    ? Utility.tryJsonParse(sessionStorage.takeawayLocation)
    : "";
  if (_?.latitude) {
    return {
      coords: {
        latitude: _.latitude,
        longitude: _.longitude,
      },
    };
  } else {
    return "";
  }
};

const storeId = () => {
  const qrOrderFlow =
    (window.location.href.includes("/qr") &&
      Utility.getLinkRewriteFromSiteprops() === "qr") ||
    getIsQrOrder();
  if (getDeliveryType() != "D") {
    let takeawayLocation = sessionStorage.takeawayLocation
      ? Utility.tryJsonParse(sessionStorage.takeawayLocation)
      : null;

    if (qrOrderFlow) {
      return (
        takeawayLocation?.id || localStorage.storeId || Location.defaultStoreId
      );
    }

    return takeawayLocation?.id || Location.defaultStoreId;
  }
  let value =
    getLastLocationNewOrLastLocationNewForIp()[0]?.recent
      ?.advanceOrderStoreId ||
    getLastLocationNewOrLastLocationNewForIp()[0]?.recent?.id ||
    Location.defaultStoreId;
  if (!value) {
    value = Location.defaultStoreId;
  }
  return value;
};

const isLoggedIn = () => {
  return localStorage.userInfo
    ? Utility.tryJsonParse(localStorage.userInfo)?.headers?.isLoggedIn
    : "";
};

const couponCode = () => {
  return localStorage.couponCode
    ? Utility.tryJsonParse(localStorage.couponCode)?.code
    : "";
};

const updateCouponCode = (payload) => {
  try {
    if (payload) {
      localStorage.couponCode = JSON.stringify({ code: payload });
    } else {
      delete localStorage.couponCode;
    }
  } catch (e) {}
};

const updateStoreId = (payload) => {
  let value = getLastLocationNewOrLastLocationNewForIp();
  try {
    if (value[0]?.recent?.advanceOrderStoreId || value[0]?.recent?.id) {
      const oldStoreId =
        value[0]?.recent?.advanceOrderStoreId || value[0]?.recent?.id;
      localStorage.storeId = oldStoreId;
      sessionStorage.previousStoreId = oldStoreId;
      value[0].recent.advanceOrderStoreId = payload.toString();
      value[0].recent.id = payload.toString();
      localStorage.storeId = value[0].recent.advanceOrderStoreId;
      sessionStorage.previousStoreId = value[0].recent.advanceOrderStoreId;

      let previousStoreIdIs =
        value[1]?.recent?.advanceOrderStoreId || value[1]?.recent?.id;
      localStorage.setItem("previousStoreId", previousStoreIdIs || "");
    }
    if (getLocationSource() == "ip") {
      localStorage.lastLocationNewForIp = JSON.stringify(value);
    } else if (localStorage.lastLocationNew) {
      localStorage.lastLocationNew = JSON.stringify(value);
      const qrOrderFlow =
        window.location.href.includes(PageNames.NEXTGEN_LINKREWRITE_QR_ORDER) &&
        Utility.getLinkRewriteFromSiteprops() === "qr";
      if (qrOrderFlow && value && Array.isArray(value) && value[0]?.recent) {
        localStorage.selectedAddress = JSON.stringify(value[0]?.recent);
      }
    }
  } catch (e) {}
};

const updateLastLocation = (payload) => {
  let _ = payload.source == "ip" ? "lastLocationNewForIp" : "lastLocationNew";
  let value = Utility.tryJsonParse(localStorage[_]);
  try {
    if (value[0]) {
      // NGH-2443: address_id was getting overwritten and is required to solve same address issue
      const { address_id = "" } = value[0]?.location || {};
      if (payload?.location && address_id) {
        payload.location["address_id"] = address_id;
      }
      value[0] = payload;
    } else {
      value = [payload];
    }
    const qrOrderFlow =
      window.location.href.includes(PageNames.NEXTGEN_LINKREWRITE_QR_ORDER) &&
      Utility.getLinkRewriteFromSiteprops() === "qr";

    localStorage[_] = JSON.stringify(value);
    if (
      qrOrderFlow &&
      _ == "lastLocationNew" &&
      value &&
      Array.isArray(value) &&
      value[0] &&
      value[0]?.recent
    ) {
      localStorage["selectedAddress"] = JSON.stringify(value[0]?.recent);
    }
    if (_ == "lastLocationNewForIp") {
      localStorage.removeItem("lastLocationNew");
    }
    if (payload?.recent?.advanceOrderStoreId || payload?.recent?.id) {
      localStorage.storeId =
        payload.recent.advanceOrderStoreId || payload?.recent?.id;
    }
  } catch (e) {}
};

const updateLoyaltyInfo = (payload) => {
  try {
    localStorage.loyaltyInfo = JSON.stringify(payload);
  } catch (e) {}
};

const getLoyaltyInfo = () => {
  return localStorage.loyaltyInfo
    ? Utility.tryJsonParse(localStorage.loyaltyInfo)
    : {};
};

const updateIsLoggedIn = (payload) => {
  let value = localStorage.userInfo
    ? Utility.tryJsonParse(localStorage.userInfo)
    : "";
  try {
    if (value?.headers) {
      value.headers.isLoggedIn = payload.isLoggedIn;
    }
    localStorage.userInfo = JSON.stringify(value);
  } catch (e) {}
};

const getDeliveryType = () => {
  let value = localStorage.userInfo
    ? Utility.tryJsonParse(localStorage.userInfo)
    : "";
  return value?.headers?.deliveryType || "D";
};

const updateCart = (payload) => {
  try {
    localStorage.cartItems = JSON.stringify(payload);
  } catch (e) {}
};

const cart = () => {
  return localStorage.cartItems
    ? Utility.tryJsonParse(localStorage.cartItems)
    : [];
};
const updateEdvItems = (payload) => {
  try {
    localStorage.edvItems = JSON.stringify(payload);
  } catch (e) {}
};

const getEdvItems = () => {
  return localStorage.edvItems
    ? Utility.tryJsonParse(localStorage.edvItems)
    : [];
};

const unsetKey = (key) => {
  localStorage.removeItem(key);
};

const setToppingsDataLocalStorage = (data) => {
  return localStorage.setItem("toppingsData", JSON.stringify(data));
};

const setCustomizedOptionKeyLocalStorage = (data) => {
  return localStorage.setItem("isCustomizedOptionEnable", JSON.stringify(data));
};

const getCustomizedOptionKeyLocalStorage = () => {
  return Utility.tryJsonParse(localStorage.getItem("isCustomizedOptionEnable"));
};
const setToppingArrayPriceKeyLocalStorage = (data) => {
  return localStorage.setItem("itemPriceToppingArray", JSON.stringify(data));
};

const updateCurrentCustomisation = (productId, data) => {
  let value = Utility.tryJsonParse(localStorage.currentCustomisation);
  if (
    data["addTopngs"]?.length > 0 ||
    data["remTopngs"]?.length > 0 ||
    data["repTopngs"]?.length > 0
  ) {
    value[productId] = data;
  }

  return localStorage.setItem("currentCustomisation", JSON.stringify(value));
};

const getToppingArrayPriceKeyLocalStorage = () => {
  return Utility.tryJsonParse(localStorage.getItem("itemPriceToppingArray"));
};

const setSelectedAndReplaceToppingsLocalStorage = (data) => {
  return localStorage.setItem(
    "selectedAndReplacedToppings",
    JSON.stringify(data),
  );
};

const getSelectedAndReplaceToppingsLocalStorage = () => {
  return Utility.tryJsonParse(
    localStorage.getItem("selectedAndReplacedToppings"),
  );
};
const setReplaceDisableLocalStorage = (data) => {
  return localStorage.setItem("replaceDisable", JSON.stringify(data));
};

const getReplaceDisableLocalStorage = () => {
  return Utility.tryJsonParse(localStorage.getItem("replaceDisable"));
};

const setCurrentSelectedToppings = (data) => {
  return localStorage.setItem("currentSelToppObj", JSON.stringify(data));
};

const getCurrentSelectedToppings = () => {
  return Utility.tryJsonParse(localStorage.getItem("currentSelToppObj"));
};

const setNextGenKeyInSession = (
  payload = window.location.origin + window.location.pathname,
) => {
  let _ = Utility.getQueryFromUrl();
  _["v"] = Utility.randomnumber();
  let queryPart = "";

  for (const [key, value] of Object.entries(_)) {
    if (key) {
      queryPart = `${queryPart}${key}=${value}&`;
    }
  }

  try {
    if (window.location.pathname === "/") {
      payload = defaultNextgenPathname + DEFAULT_STORE;
    }
    payload = payload + "?" + queryPart;
    sessionStorage.nextgenhomepage = payload;
    sessionStorage.currentNextgenFolder =
      Utility.getCurrentStoreFolder().replace(/^\/+|\/+$/g, "");
  } catch (e) {}
};

const getLocationAnimationKey = () => {
  return Utility.tryJsonParse(localStorage.getItem("showLocationAnimation"));
};
const setLocationAnimationKey = (val) => {
  return localStorage.setItem("showLocationAnimation", val);
};

const updatePaymentOfferpaymentId = (payload) => {
  try {
    if (payload) {
      localStorage.paymentMode = JSON.stringify(payload);
    } else {
      delete localStorage.paymentMode;
    }
  } catch (e) {}
};

const getPaymentOfferPaymentIdLS = () => {
  return localStorage.paymentMode
    ? Utility.tryJsonParse(localStorage.paymentMode)?.paymentId
    : "";
};

const getPaymentOfferMode = () => {
  return localStorage.paymentMode
    ? Utility.tryJsonParse(localStorage.paymentMode)
    : "";
};

const getCouponCode = () => {
  return Utility.tryJsonParse(localStorage.getItem("couponCode"));
};

const getTrackerIdData = () => {
  return localStorage.tracker_id_mobile
    ? Utility.tryJsonParse(localStorage.tracker_id_mobile)
    : {};
};

const getDeliveryTypeStationData = () => {
  return Utility.tryJsonParse(localStorage.getItem("deliveryTypeStationData"));
};
const setDeliveryTypeStationData = (val) => {
  return localStorage.setItem("deliveryTypeStationData", val);
};

const setTrackerIdMobile = (val) => {
  const { orderId, mobile } = val;
  if (orderId && mobile) {
    return (sessionStorage.tracker_id_mobile = JSON.stringify({
      orderId: val.orderId,
      mobile: val.mobile,
    }));
  }
};

const setLoginSkippedStatusInSession = () => {
  sessionStorage.hideLoginPopup = JSON.stringify(true);
};

const getLoginSkippedStatusFromSession = () => {
  return sessionStorage.hideLoginPopup
    ? Utility.tryJsonParse(sessionStorage.hideLoginPopup)
    : false;
};

const setPaymentModeAvailable = (data) => {
  localStorage.isPaymentModeAvailable =
    typeof data === "object" ? JSON.stringify(data) : data;
};

const setWalletSelected = (data) => {
  localStorage.isWalletSelected =
    typeof data === "object" ? JSON.stringify(data) : data;
};

const setTotalWalletBalance = (data) => {
  localStorage.totalWalletBalance =
    typeof data === "object" ? JSON.stringify(data) : data;
};

const setUtmAttributes = (value) => {
  localStorage.utm_attributes = JSON.stringify(value);
};

const getUtmAttributes = () => {
  return localStorage.utm_attributes
    ? Utility.tryJsonParse(localStorage.utm_attributes)
    : "";
};

const setUtmTimestamp = (value) => {
  localStorage.time_stamp_utm = JSON.stringify(value);
};

const getUtmTimestamp = () => {
  return localStorage.time_stamp_utm
    ? Utility.tryJsonParse(localStorage.time_stamp_utm)
    : "";
};

const getOrderTypeSubtitle = () => {
  return localStorage.orderTypeSubtitle
    ? Utility.tryJsonParse(localStorage.orderTypeSubtitle)
    : "";
};

const setOrderTypeSubtitle = (value) => {
  localStorage.orderTypeSubtitle = JSON.stringify(value);
};

const getMenuLoadEventFiredFor = () => {
  return sessionStorage.menuLoadEventFiredFor
    ? Utility.tryJsonParse(sessionStorage.menuLoadEventFiredFor)
    : "";
};

const setMenuLoadEventFiredFor = (value) => {
  sessionStorage.menuLoadEventFiredFor = JSON.stringify(value);
};
const getStoreIdOfLastStoreStatusEvent = () => {
  return sessionStorage.storeIdOfLastStoreStatusEvent
    ? Utility.tryJsonParse(sessionStorage.storeIdOfLastStoreStatusEvent)
    : "";
};

const setStoreIdOfLastStoreStatusEvent = (value) => {
  return (sessionStorage.storeIdOfLastStoreStatusEvent = JSON.stringify(value));
};

const getSplashLottieiUrl = () => {
  return localStorage.splashLottieUrl
    ? Utility.tryJsonParse(localStorage.splashLottieUrl)
    : "";
};

const getSplashLottieiJson = () => {
  return localStorage.splashLottieJson
    ? Utility.tryJsonParse(localStorage.splashLottieJson)
    : {};
};

const getSplashImageUrl = () => {
  return localStorage.splashImageUrl
    ? Utility.tryJsonParse(localStorage.splashImageUrl)
    : "";
};

const getSplashImageTimer = () => {
  return localStorage.splashImageUrl
    ? Utility.tryJsonParse(localStorage.splashImageTimer)
    : "";
};

const getMobileNumber = () => {
  try {
    if (
      getUserData()?.userData !== undefined &&
      getUserData()?.userData?.mobile
    ) {
      return Number(getUserData()?.userData?.mobile);
    } else if (getAddressDetail()?.mobNo) {
      return Number(getAddressDetail()?.mobNo);
    } else if (localStorage.mobileNo) {
      return Number(Utility.tryJsonParse(localStorage.getItem("mobileNo")));
    } else {
      return "";
    }
  } catch (e) {}
};

const getUserLocationData = () => {
  let userLocationData = localStorage.userLocationData;
  try {
    if (userLocationData && typeof userLocationData === "string") {
      userLocationData = Utility.decryptData(userLocationData);
    }
    return JSON.parse(userLocationData);
  } catch {
    return userLocationData;
  }
};

const setUserLocationData = (data) => {
  if (data && typeof data === "object") {
    const data1 = Utility.encryptData(data);
    localStorage.userLocationData = data1;
  } else {
    localStorage.userLocationData = JSON.stringify(data);
  }
};

const getPendingOrderConfirmationTimerLimit = () => {
  const timerLimit = localStorage.getItem("pendingOrderConfirmationTimerLimit");
  if (!timerLimit) return 0;
  const remaining = timerLimit - Date.now();
  return Math.ceil(Math.max(0, remaining) / 1000);
};

const getPendingOrderConfirmationTimer = () => {
  const timer = localStorage.getItem("pendingOrderConfirmationTimer");
  if (!timer) return 0;
  return timer;
};

const setDeliveryType = (orderType) => {
  let userInfo = getUserData();
  if (
    !userInfo ||
    (typeof userInfo === "object" && !Object.keys(userInfo).length)
  ) {
    userInfo = {
      headers: {
        deliveryType: orderType,
      },
    };
  } else {
    const tempUserInfo = {
      ...userInfo,
    };
    userInfo = {
      ...tempUserInfo,
      headers: { ...tempUserInfo.headers, deliveryType: orderType },
    };
  }

  setUserData(userInfo);
};

const clearStoreData = () => {
  setLocalStorageValue("confrimView", false);
  setLocalStorageValue("transactionId", "");
  setLocalStorageValue("displayNetPrice", "");
  setLocalStorageValue("cartItems", JSON.stringify([]));
  setLocalStorageValue("menuItems", JSON.stringify({}));
  setLocalStorageValue("LOYALTY_ITEMS", JSON.stringify([]));
  setLocalStorageValue("edvItems", JSON.stringify([]));
  setLocalStorageValue("paymentMode", "");
  setLocalStorageValue("previousPaymentMode", "");
  setLocalStorageValue("isPaymentModeAvailable", "");
  setLocalStorageValue("isWalletSelected", "");
  setLocalStorageValue("totalWalletBalance", "");
  setLocalStorageValue("couponCode", "");
  setLocalStorageValue("TRANSACTION_STATUS", "");
  setLocalStorageValue("isAdvanceOrder", false);
  setLocalStorageValue("optionalCharge", JSON.stringify([]));
  setLocalStorageValue("cartProperties", JSON.stringify([]));
  delete localStorage.advanceTime;
};

const getIsQrOrder = () => {
  return sessionStorage.qrOrder
    ? Utility.tryJsonParse(sessionStorage.qrOrder)
    : false;
};

export default {
  setLocalStorageValue,
  getStorageValue,
  getLastLocationNewOrLastLocationNewForIp,
  isMiniAppPaytmGpay,
  getIsLocationPermisssionGiven,
  setIsLocationPermissionGiven,
  setAskLocationLaterInSession,
  getAskLocationLaterFromSession,
  setHideLocationPopupOnceInSession,
  getHideLocationPopupOnceFromSession,
  conditionalPurgeStorage,
  cartId,
  getReturnedFromMapScreen,
  setReturnedFromMapScreen,
  setNoDeliveryZoneInSession,
  getLocationSource,
  isLocationSelectedFromPwaV2,
  setLocationSelectedFromPwaV2,
  unsetSessionStorageKey,
  setSessionStorageKey,
  getSessionStorageKey,
  setLocationSource,
  getUserData,
  getCorporateUserInfo,
  setCorporateUserInfo,
  getCoordsFromRecentLocation,
  getCoordsForTakeaway,
  storeId,
  updateStoreId,
  updateLastLocation,
  updateLoyaltyInfo,
  updateIsLoggedIn,
  getDeliveryType,
  isLoggedIn,
  updateCart,
  cart,
  unsetKey,
  setToppingsDataLocalStorage,
  updateCurrentCustomisation,
  setCustomizedOptionKeyLocalStorage,
  getCustomizedOptionKeyLocalStorage,
  setToppingArrayPriceKeyLocalStorage,
  getToppingArrayPriceKeyLocalStorage,
  setSelectedAndReplaceToppingsLocalStorage,
  getSelectedAndReplaceToppingsLocalStorage,
  setReplaceDisableLocalStorage,
  getReplaceDisableLocalStorage,
  setCurrentSelectedToppings,
  getCurrentSelectedToppings,
  couponCode,
  updateCouponCode,
  setNextGenKeyInSession,
  setLocationAnimationKey,
  getLocationAnimationKey,
  updatePaymentOfferpaymentId,
  getPaymentOfferPaymentIdLS,
  getCouponCode,
  getTrackerIdData,
  getPaymentOfferMode,
  getDeliveryTypeStationData,
  setDeliveryTypeStationData,
  setTrackerOfKeyInSession,
  getIsStoreIdCacheEligible,
  setIsStoreIdCacheEligible,
  setComputedLocationData,
  getComputedLocationData,
  setIsTrueLocationDetected,
  getIsTrueLocationDetected,
  setTrackerIdMobile,
  getPreviousStoreId,
  setLoginSkippedStatusInSession,
  getLoginSkippedStatusFromSession,
  setUserData,
  setUserAddress,
  getAddressDetail,
  setAddressDetail,
  setPaymentModeAvailable,
  setWalletSelected,
  setTotalWalletBalance,
  getSessionStorageValuePwaV2Keys,
  nearestApiTopAddress,
  setNearestApiTopAddress,
  setUtmAttributes,
  getUtmAttributes,
  getUtmTimestamp,
  setUtmTimestamp,
  nearestApiTopAddress,
  setNearestApiTopAddress,
  getOrderTypeSubtitle,
  setOrderTypeSubtitle,
  getMenuLoadEventFiredFor,
  setMenuLoadEventFiredFor,
  getStoreIdOfLastStoreStatusEvent,
  setStoreIdOfLastStoreStatusEvent,
  getCartData,
  getSplashLottieiUrl,
  getSplashLottieiJson,
  getSplashImageUrl,
  getSplashImageTimer,
  getEdvItems,
  updateEdvItems,
  getMobileNumber,
  getSgRefundAmt,
  getUserLocationData,
  setUserLocationData,
  getUserId,
  getPendingOrderConfirmationTimerLimit,
  getPendingOrderConfirmationTimer,
  clearStoreData,
  setLoyTnc,
  getLoyTnc,
  getLoyaltyInfo,
  getIsQrOrder,
  setDeliveryType,
};
